export default __webpack_public_path__ + "static/b4-48ac65820060d24085b87dec25123862.png";